import trustpilotData from '@/data/trustpilot-data.json';
import { logEvent } from '@/pages/api/v1/utils';
import { TrustPilotImage } from './TrustPilotImage';
import type { TrustPilotData } from '@/components/TrustPilot/types';
const UBTrustBoxContainer = () => {
  const data = trustpilotData as TrustPilotData;
  return <a className="flex items-center justify-center md:justify-start" href="https://uk.trustpilot.com/review/uppbeat.io" onClick={() => {
    void logEvent({
      event_type: 'click',
      asPath: `${window.location.pathname}${window.location.search}`,
      metadata: {
        type: 'trustpilot_link'
      }
    });
  }} rel="noreferrer noopener" target="_blank" data-sentry-component="UBTrustBoxContainer" data-sentry-source-file="index.tsx">
      <TrustPilotImage stars={data.businessUnit.stars} totalReviews={data.businessUnit.numberOfReviews.total} trustScore={data.businessUnit.trustScore} data-sentry-element="TrustPilotImage" data-sentry-source-file="index.tsx" />
    </a>;
};
export default UBTrustBoxContainer;